import { Translation } from "../../i18n/translation";
import { TransTokens } from "../../i18n/trans-tokens";

export const ErrorTokens: { [key: string]: Translation } = TransTokens.create({
  ERR_NO_ACCESS: "You don't have access to this content.",
  ERR_UNAUTHORIZED: "You are not signed in. Please sign in.",
  ERR_NO_DIVISION_ACCESS: "You don't have access to this content.",
  ERR_DIVISION_NOT_AVAILABLE: "This content is no longer available.",

  ERR_CONTENT_NOT_FOUND: "Content could not be found.",
  ERR_DUPLICATE_KEY_ERROR: "Error while saving the data. Data already exists.",
  ERR_INTERNAL_SERVER_ERROR:
    "An unspecified error occured. Please try again later, or contact us if this issue perists.",
  TOKEN_EXPIRED:
    "The token you used is expired or invalid. Please login in again.",
});
